<template>
  <AbsPopup id="CsReport" title="비공개 수정요청" @close="$emit('close')" @submit="submit" :initButtonList="buttonList">
    <template #body>
      <div class="popup-body">
        <span>수정하신 내용은 7일 이내에 확인 후 반영이 되며 <u>내용이 부적절할<br />경우 수정 내용이 반영되지 않을 수 있습니다.</u></span>
        <div>
          <span class="right">공백포함 {{ textSize }} / {{ total }}</span>
        </div>
        <UInput type="textarea" :limitHeight="100" :auto="true" placeholder="내용을 입력해 주세요" v-model="commentEx" :limit="500" @focus="$store.commit('popup', false)" @focusout="$store.commit('popup', true)"/>
      </div>
    </template>
  </AbsPopup>
</template>

<script>
import AbsPopup from '@/components/popup/AbsPopup.vue'
import UInput from '@/components/base/UInput.vue'
import TabBar from '@/components/layout/TabBar.vue'
// import {numberToComma, commaToNumber} from '@/components/js/Utils'

export default {
  props: {
    option: {
      type: Object
    }
  },
  mounted () {
    this.$http.post('/api/user/myInfo').then((row) => {
      console.log(row)
      if (row.success) {
        this.info = row
        this.$emit('loading', false)
      } else {
      }
    })
  },
  data: () => {
    return {
      total: 300,
      info: null,
      commentEx: '',
      commentIdx: -1
    }
  },
  name: 'CsReport',
  watch: {
  },
  computed: {
    buttonList () {
      return [
        {name: '취소', state: 'deactive', click: () => { this.$emit('close') }},
        {name: '확인', state: 'require', click: this.submit}
      ]
    },
    textSize () {
      return this.commentEx.length
    }
  },
  methods: {
    submit () {
      console.log('submit')
      this.$http.post('/api/cs/comment', {id: this.option.param._id, comment: this.commentEx}).then((row) => {
        console.log(row)
        if (row.success) {
          this.$emit('submit', this.option.param)
        } else {
        }
      })
    }
  },
  components: {
    AbsPopup,
    UInput,
    TabBar
  }
}
</script>

<style scoped>
.popup-body {
  margin: 10px 20px;
  width: 410px;
  text-align: left;
  line-height: 30px;
  display: flex;
  flex-direction: column;
  color: var(--text-base);
}
.popup-body > span {
  margin-bottom: 15px;
}
.popup-body .right {
  display: flex;
}
.popup-body > div {
  display: flex;
}
.popup-body .input {
  display: flex;
  flex-direction: row;
  flex: 1;
  border: 1px solid var(--line-guide);
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/CsReport.vue